var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5006_9457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9263 19.5357H39.7896L35.6067 23.0708V28.4012L39.3454 25.2177H39.5213L39.3177 37.1279C39.3177 37.7109 39.0123 38.2477 38.5126 38.5531C35.4309 40.4502 24.3814 47.2335 23.0858 47.2335C21.5773 47.2335 20.365 46.012 20.365 44.5128V27.1334C20.365 25.0512 21.4848 23.1355 23.2986 22.1176L42.9453 11.0866L22.984 0L3.61491 10.7349C1.78258 11.7529 0.653564 13.6777 0.653564 15.7692V34.7681C0.653564 36.7855 1.73631 38.6456 3.48535 39.6543L19.0417 48.5754C21.7717 50.1393 25.131 50.1208 27.8424 48.5291L42.6584 39.8024C44.352 38.8029 45.3977 36.9798 45.3977 35.018V21.0071C45.3977 20.202 44.7406 19.5449 43.9355 19.5449L43.9263 19.5357Z",
    fill: "#2768FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5006_9457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7349,
    height: 49.7322,
    fill: "white",
    transform: "translate(0.654053)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLogin);
export default __webpack_public_path__ + "static/media/logo-login.4dbb7a9610a51b9b9a5a6f83be8efb60.svg";
export { ForwardRef as ReactComponent };